







































import Vue from 'vue';
import { Expression, ChainExpression, ReturnExpression, NoExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';
import { getConfirmation } from '../../../app/Confirm';
import { Preferences, PreferenceCategory } from '../../../app/Preference';


const PREF_RETURN_REMOVE = Preferences.define({
  key: 'return_remove',
  label: 'Remove return without confirmation',
  category: [PreferenceCategory.EXPRESSION, PreferenceCategory.CONFIRM],
  defaultValue: false,
});


export default ExpressionBase<ReturnExpression>().extend({
  name: 'ReturnEditor',
  computed: {
    canRemoveReturn(): boolean {
      return this.value.value === NoExpression.instance;
    },
  },
  methods: {
    updateValue(expr?: Expression) {
      this.value.value = expr || NoExpression.instance;
      this.update();
    },
    async removeReturn() {
      if (await getConfirmation({ pref: PREF_RETURN_REMOVE })) {
        this.input(this.value.value);
      }
    },
  },
});
